var map = {
	"./AXA.png": 110,
	"./Allianz.png": 829,
	"./Aviva.png": 963,
	"./Bupa.png": 362,
	"./Cigna.jpeg": 191,
	"./Freedom.png": 624,
	"./TheExeter.png": 438,
	"./Vitality.png": 134,
	"./WPA.png": 456,
	"./footer-logo.png": 421,
	"./logo.png": 845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 366;